import { Placement, PopoverProps } from './types';
import cn from 'classnames';
import { Tooltip } from 'react-tooltip';
import styles from './Popover.module.scss';

export function Popover({
  anchor,
  children,
  className,
  placement,
  clickable,
  opened,
  offset,
  arrow,
  setOpened,
  maxHeight = 135,
  text,
}: PopoverProps) {
  const popoverClassName = cn(
    styles.popover,
    {
      [styles.bottomStart]: placement === Placement.BottomStart,
      [styles.arrow]: arrow,
    },
    className,
  );

  return (
    <Tooltip
      place={placement}
      clickable={clickable}
      id={anchor}
      noArrow={!arrow}
      openOnClick
      isOpen={opened}
      offset={offset}
      setIsOpen={setOpened}
      className={popoverClassName}
    >
      <div
        className={maxHeight ? styles.bodyWithScroll : styles.body}
        style={{ maxHeight: maxHeight ? maxHeight : 'auto' }}
      >
        {text && (
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className={styles.body}
            style={{ marginBottom: '8px' }}
          />
        )}
        {children}
      </div>
    </Tooltip>
  );
}
